<div class="slider-item"
  [ngClass]="{'slider-item-selector': !slidItemClass, 'zindex': addZindex, 'cardOverlay': currentlyPlaying}"
  [@videoCardAnimation] (click)="videoCardFullClick(video)">
  <!-- <div class="slider-img" [attr.vidoe-slug]="video.slug" lazy-load-images (click)="videoClick(video);"> -->

  <div class="slider-img" [attr.vidoe-slug]="video.slug" lazy-load-images (click)="videoClick(video,'image');">
    <img [attr.alt]="video.title" src="https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png"
      [attr.data-src]="video.thumbnail_image">
    <span class="play-video" *ngIf="this.type !== 'upcoming'"></span>
    <span *ngIf="this.type !== 'webseries'">
      <span class="play-video" *ngIf="this.type !== 'upcoming'"></span>
    </span>
    <span class="free-tag"> Free</span>
    <span class="premium-tag pts" *ngIf="video?.is_premium === 1"> 
      P
    </span>
    <span *ngIf="type === 'favorite'" class="like-box" (click)="favourite(video, $event)"><i
        [ngClass]="'liked'"></i></span>
    <div *ngIf="video?.video_duration" class="duration">{{video?.video_duration}}</div>
  </div>
  <div class="slider-content">
    <ng-container *ngIf="type !== 'web-series' || video.is_shorts !=1  else webSeries">
      <h3 [ngClass]="{'center': type === 'webseries'}" (click)="videoClick(video, undefined)">

        {{video?.title}}
      </h3>
      <!-- <span class="category-text" (click)="videoClick(video, undefined);"
        *ngIf="type !== 'search' && type !== 'upcoming'">
        <ng-container *ngIf="category !== 'genre' && type !== 'upcoming' && type !== 'live'">
          {{video?.genre_name}}<i
            *ngIf="video?.genre_name && category !== 'genre' && category !== 'category' && video?.video_category_name">,</i>
        </ng-container>
        <ng-container *ngIf="video?.video_category_name && category !== 'category'">
          {{video?.video_category_name}}
        </ng-container>
      </span> -->

      <!-- <span class="category-text" *ngIf="type === 'search'" (click)="videoClick(video, undefined);">
        {{video?.genre_name}}<i *ngIf="video?.genre_name">,</i>{{video?.video_category_name}}
      </span> -->
    </ng-container>
    <ng-template #webSeries>
      <p (click)="videoClick(video, undefined)">
        <ng-container class="category-text" (click)="videoClick(video, undefined);"
          *ngIf="type !== 'search' && type !== 'upcoming' && type !== 'webseries'">
          <ng-container *ngIf="video?.video_category_name">
            {{video?.video_category_name}}
          </ng-container>
        </ng-container>

        <ng-container class="category-text" *ngIf="type === 'search'" (click)="videoClick(video, undefined);">
          {{video?.category_name}}
        </ng-container>
      </p>
      <!-- <span class="category-text" (click)="videoClick(video, undefined);">
        <ng-container *ngIf="category !== 'genre'">{{video?.genre_name }}<i *ngIf="video?.genre_name">, </i>
        </ng-container>{{video?.title}}
      </span> -->
      <p (click)="videoClick(video, undefined)">
        <ng-container class="category-text" (click)="videoClick(video, undefined);"
          *ngIf="!live && type !== 'search' && category !== 'category'">
          <ng-container *ngIf="video?.title">
            {{video?.title}}
          </ng-container>
        </ng-container>
        <!-- <ng-container class="category-text" *ngIf="type === 'search'" (click)="videoClick(video, undefined);">
          {{video?.category_name}}
        </ng-container> -->
      </p>


    </ng-template>
    <span class="time" *ngIf="type === 'upcoming'" (click)="videoClick(video, undefined);">
      {{video?.scheduledStartTime | date: 'MMM dd yyyy' }}
      {{video?.scheduledStartTime | date: 'hh:mm'}}{{video?.scheduledStartTime | date: 'a' | lowercase}}
    </span>
    <div class="video-options" id="video{{ video.slug }}"
      *ngIf="type !== 'live' && type !== 'upcoming' && addOrRemove === true" (click)="showOptions($event)">
      <svg xmlns="http://www.w3.org/2000/svg" id="video1{{ video.slug }}" xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 384 384" style="enable-background:new 0 0 384 384;"
        xml:space="preserve" width="20px" height="20px">
        <g>
          <g>
            <circle cx="192" cy="42.667" r="46.667" fill="#696969" />
          </g>
        </g>
        <g>
          <g>
            <circle cx="192" cy="192" r="46.667" fill="#696969" />
          </g>
        </g>
        <g>
          <g>
            <circle cx="192" cy="341.333" r="46.667" fill="#696969" />
          </g>
        </g>
      </svg>
      <div class="video-option-list" [ngClass]="{ 'show' : showOption }">
        <ul>
          <li *ngIf="!history" (click)="openShareVideo()">
            <a><i class="share-icon"></i>{{ 'VIDEO_CARD.SHARE' | translate }}</a>
          </li>
          <li *ngIf="!history && !playlist_id" (click)="openPlalistPopup()">
            <a><i class="playlist-icon"></i>{{ 'VIDEO_CARD.ADD_TO_PLAYLIST' | translate }}</a>
          </li>
          <li *ngIf="!history && playlist_id" (click)="removeFromPlaylist(video, $event)">
            <a><i class="playlist-icon"></i>{{ 'VIDEO_CARD.REMOVE_FROM_PLAYLIST' | translate }}</a>
          </li>
          <li *ngIf="history" (click)="removeHistory(video, $event)">
            <a>{{ 'VIDEO_CARD.REMOVE_FROM_HISTORY' | translate }}</a>
          </li>
        </ul>
        <div class="overlay"></div>
      </div>
    </div>
    <span class="live-icon" *ngIf="type === 'live'">
      <svg version="1.1" id="Layer_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px"
        height="30px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve">
        <path fill="#5ea326" d="M26.387,23.657l-1.261-1.263c4.122-4.123,4.121-10.83-0.002-14.953l1.263-1.261
        	C31.205,10.998,31.205,18.84,26.387,23.657z M22.942,20.212l1.261,1.266c3.614-3.617,3.614-9.5,0-13.115l-1.261,1.261
        	C25.86,12.542,25.86,17.295,22.942,20.212z M21.952,19.224c2.374-2.373,2.374-6.238-0.001-8.611l-1.261,1.262
        	c1.68,1.68,1.68,4.411,0,6.086L21.952,19.224z M5.353,7.441L4.09,6.18c-4.818,4.817-4.818,12.66,0,17.477l1.261-1.263
        	C1.229,18.273,1.23,11.565,5.353,7.441z M6.271,21.478l1.262-1.266c-2.918-2.917-2.918-7.667,0-10.588L6.271,8.361
        	C2.656,11.976,2.656,17.86,6.271,21.478z M8.522,19.224l1.263-1.263c-1.678-1.679-1.678-4.409,0.001-6.086l-1.263-1.262
        	C6.149,12.989,6.149,16.852,8.522,19.224z" />
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#5ea326" d="M15.366,12.178c1.646,0,2.98,1.335,2.98,2.981
        	s-1.334,2.98-2.98,2.98s-2.981-1.334-2.981-2.98S13.72,12.178,15.366,12.178z" />
      </svg>
    </span>
  </div>
</div>